import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "./tree.css";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogActions } from "@material-ui/core";
import { Trans, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import { taxServiceClient } from "../../AxiosClient";
import Pagination from "@material-ui/lab/Pagination";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
const styles = (theme) => ({
  formControl: {
    minWidth: 182,
  },
  TeamDialog: {
    minWidth: 300,
    minHeight: 300,
    overflow: "auto",
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class TeamSelector extends Component {
  state = {
    teamDialogOpen: false,
    canSelect: true,
    teamSelected:{},
    teams:[],
    page:1,
    size:20,
    totalElements:300,
    totalPages:1,
    search:"",
  };

  componentDidMount() {
    this.getTeams();
    if(this.props.value){
      this.getLabel();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.search != this.state.search){
      this.getTeams();
    }
    if(prevProps.value != this.props.value){
      this.getLabel();
    }
  }

  keypress = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      this.openTeamDialog();
    }
  };
  getTeams = () => {
    taxServiceClient.get("/team/",{
      params: {
       search: this.state.search,
       size: 5,
       page: this.state.page - 1,
      },
    }).then((res) => {
      this.setState({teams:res.data.content, totalElements:res.data.totalElements,totalPages:res.data.totalPages});
    });
  }
  handlePaginationChange = (event, value) => {
    this.setState({page: value}, this.getTeams());
  }
  getLabel = () =>  {
    // taxServiceClient.get("/team/"+this.props.value+"?organizationId=" + this.props.currentUser.organization.organizationId).then((res) => {
    //   this.setState({teamSelected:res.data});
    // });

    if(this.props.currentUser){
      let team = this.props.currentUser.teams.filter(team=> team.teamId===this.props.value
      )
      this.setState({teamSelected:team[0]});
    }
  }

  render() {
    const { classes, t } = this.props;
    return (
      <>
        <TextField
          aria-label="Team selector"
          onKeyDown={this.keypress}
          id="TeamNode"
          label={"Select team"}
          value={this.state.teamSelected && this.state.teamSelected.teamName ? this.state.teamSelected.teamName : this.props.value}
          onClick={this.openTeamDialog}
          InputProps={{
            readOnly: true,
          }}
        />

        <Dialog
          open={this.state.teamDialogOpen}
          onClose={this.handleTeamDialogClose}
          style={{ zIndex: 10002 }}
        >
          <DialogTitle>
            Teams
          </DialogTitle>
          <DialogContent className={classes.TeamDialog}>
          <TextField
            label={t("global_search")}
            value={this.state.search}
            onChange={(e)=>this.setState({search:e.target.value})}
          />
            <List style ={{minHeight: '250px'}}>
              {this.state.teams.map((team,idx)=>(
                 <ListItem
                 key={idx}
                 button
               //  component="div"
                 onClick={() => {this.handleTeamDialogClose(); this.setState({teamSelected:team}); this.props.onChange(team)}}
               >
                  <ListItemText>
                    {team.teamName}
                  </ListItemText>
                </ListItem>
              ))}
            </List>
            <div style={{display: "flex"}}></div>
            <div style={{display: "flex"}}>
              <Pagination
                style={{ marginLeft: "auto",marginRight: "auto",display: "flex"}}
                //size="small"
                showFirstButton
                showLastButton
                count={this.state.totalPages}
                page={this.state.page}
                onChange={this.handlePaginationChange}
              />
            </div>
          </DialogContent>
          <DialogActions>
              <Button onClick={this.handleTeamDialogCancel} color="primary">
                <Trans i18nKey="global_close" />
              </Button>

              {/* <Button
                onClick={this.handleTeamDialogSubmit}
                color="primary"
                disabled={this.state.canSelect}
              >
                <Trans
                  i18nKey={"global_select"}
                />
              </Button> */}
          </DialogActions>
        </Dialog>
      </>
    );
  }

  openTeamDialog = () => {
    this.setState({ teamDialogOpen: true });
  };
  handleTeamDialogClose = () => {
    this.setState({ teamDialogOpen: false });
  };
  handleTeamDialogSubmit = () => {
    this.handleTeamDialogClose();
  };
  handleTeamDialogCancel = () => {
    this.setState({ teamDialogOpen: false, TeamNode: { name: "" } });
  };
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,

});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(TeamSelector)));
